/** Internal */
import { gql } from "lib/apolloClient";

export const getOrganizationStaffQuery = gql`
  query getOrganizationStaff(
    $id: ID!
    $staffFilters: OrgConnectionFilterInput
    $allGradesFilters: AllGradesFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        staff(
          orderBy: FIRST_NAME
          orderByDirection: ASC
          filters: $staffFilters
        ) {
          edges {
            node {
              id
              firstName
              lastName
              profileImage
              coursesV2 {
                totalCount
              }
              studentsRelation {
                totalCount
              }
              allGrades(filters: $allGradesFilters) {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
